import { render } from "./InTheWorksJobs.vue?vue&type=template&id=be1d9dee"
import script from "./InTheWorksJobs.vue?vue&type=script&lang=js"
export * from "./InTheWorksJobs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__